import FileCrud from './FileCrud'
export {FileCrud}
export default FileCrud
